const SIGNED_LOADER_COMPONENT_PROPS = {
  animation: 'animation_loader_primary',
  dataTestId: 'checkout-signed-loader',
};

export { SIGNED_LOADER_COMPONENT_PROPS };
